import { render, staticRenderFns } from "./UserBusinessCard.vue?vue&type=template&id=3eca9b60&scoped=true&"
import script from "./UserBusinessCard.vue?vue&type=script&lang=js&"
export * from "./UserBusinessCard.vue?vue&type=script&lang=js&"
import style0 from "./UserBusinessCard.vue?vue&type=style&index=0&id=3eca9b60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eca9b60",
  null
  
)

export default component.exports